export default "__VITE_ASSET__BlOZ1$Ds__"